export enum InterventionCreateRequestType {
    StaWarranty = "STA",
    StaNoWarranty = "STA_NO_WARRANTY",
    Warranty = "WARRANTY",
    NoWarranty = "NO_WARRANTY"
}
